import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import ClientDashboard from '@/pages/ClientDashboard';
import TrainerDashboard from '@/pages/TrainerDashboard';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export { API, BACKEND_URL };

// Haptic feedback function
// Note: iOS Safari doesn't support Vibration API due to security restrictions
// This works primarily on Android devices (Chrome, Firefox, Samsung Internet)
export const triggerHaptic = (intensity = 'light') => {
  // Only attempt on Android or desktop Chrome (not iOS)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // Skip on iOS - Safari blocks Vibration API
  if (isIOS) return;
  
  // Check if Vibration API is available
  if (!('vibrate' in navigator)) return;
  
  try {
    switch(intensity) {
      case 'light':
        navigator.vibrate(10);
        break;
      case 'medium':
        navigator.vibrate(20);
        break;
      case 'heavy':
        navigator.vibrate([15, 10, 15]);
        break;
      case 'success':
        navigator.vibrate([10, 50, 10]);
        break;
      default:
        navigator.vibrate(10);
    }
  } catch (e) {
    // Silently fail if blocked by user settings or browser policy
  }
};

// Auth context
export const AuthContext = React.createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        setUser(response.data);
        setLoading(false);
      })
      .catch(() => {
        localStorage.removeItem('token');
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-white text-xl">Učitavanje...</div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={!user ? <LandingPage /> : user.role === 'trainer' ? <Navigate to="/trainer" /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={user && user.role === 'client' ? <ClientDashboard /> : <Navigate to="/" />} />
          <Route path="/trainer" element={user && user.role === 'trainer' ? <TrainerDashboard /> : <Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthContext.Provider>
  );
}

export default App;
